const state = {
  network: {
    page: {
      current_page: 0,
      last_page: 0,
      per_page: 25,
      total: 0
    },
    sort: {
      field: '',
      descending: false
    },
    isBusy: false
  }
}

const getters = {
  loading: state => state.network.isBusy,
  status: state => {
    return {
      descending: state.network.sort.descending,
      page: state.network.page.current_page,
      rowsPerPage: state.network.page.per_page, // -1 for All",
      sortBy: state.network.sort.field,
      totalItems: state.network.page.total
    }
  }
}

const mutations = {
  SET_LOADING (state, loading) {
    state.network.isBusy = loading
  },

  SET_PAGINATION (state, meta) {
    state.network.page = meta
  },

  SET_SORTING (state, page) {
    state.network.sort.descending = page.descending
    state.network.sort.field = page.sortBy
  }
}

const actions = {
  updateLoadingState ({ state, commit }, loading) {
    commit('SET_LOADING', loading)
  },

  updatePagination ({ state, commit }, meta) {
    commit('SET_PAGINATION', meta)
  },

  updateSorting ({ state, commit }, page) {
    commit('SET_SORTING', page)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
